// removed by extract-text-webpack-plugin
module.exports = {"wrapper-border":"magazines_1x4VV","wrapper-border__options":"magazines_1FBqZ","wrapper-border__divider":"magazines_37YCI","wrapper-border__button-color":"magazines_2sA1r","wrapper-border__borders":"magazines_28Kwi","wrapper-border__active":"magazines__hXH6","wrapper-border__popover":"magazines_1Weam"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/Border/styles.scss
// module id = 1218
// module chunks = 1